import { PageController } from '@client/components/_core/layout/PageController';
import { WalletTransactionsTable } from '@client/components/financials/wallet/WalletTransactionsTable';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/financials/billing/transactions')({
    component: Transactions,
});

function Transactions() {
    const orgId = useOrgId();

    return (
        <PageController route={Route}>
            <WalletTransactionsTable scope="org" orgId={orgId} />
        </PageController>
    );
}
